var userAgent = navigator.userAgent;

var isIOS = userAgent.indexOf('kabala-ios') > -1;
if(isIOS){
	$kmobilebridge = require('./kabala-iosbridge');
	// document.write("<script type='text/javascript' src='/kabala/js/kabala-iosbridge.js'></script>");
}

const $kmobile={
	alert:function(text){/***客户端toast消息 ****/
		$kmobilebridge.alert(text);
	},
	loginbypassword:function(servername,enable,username,password,logintype){/***登录 ****/
		var javadata = $kmobilebridge.loginbypassword(servername,enable,username,password,logintype);
		if( (typeof javadata) =="string" ){
			return eval("("+javadata+")");
		}else{
			return javadata;
		}
	},
	destory:function(){/*** 注销 ****/
		$kmobilebridge.destory();
	},
	kabalamobile_invoke:function(op,param){/*** 客户端调用函数,此函数会抛出异常 ****/
		var javadata = $kmobilebridge.kabalamobile_invoke(op,JSON.stringify(param) );
		console.log('调用后返回数据=====>')
		console.log(javadata)
		console.log('调用后返回数据=====>')

		
		if( (typeof javadata) =="string" ){
			javadata =  eval("("+javadata+")");
		}
		if(javadata.code<0){
			throw javadata.message;
		}
		return javadata.data;
	},
	exitapp:function(){/** 退出程序 ***/
		$kmobile.kabalamobile_invoke("exitapp");
	},
	setcfg:function(key,value){/** 设置一个变量的参数值 ***/
		$kmobile.kabalamobile_invoke("setcfg",{key:key,value:value});	
	},
	getcfg:function(key){ /** 获取一个参数的值 ***/
		return $kmobile.kabalamobile_invoke("getcfg",{key:key}).value;	
	},
	session:function(session){/** 获取或设置session **/
		if(session){
			$kmobile.kabalamobile_invoke("session",{session:session});		
		}else{
			return $kmobile.kabalamobile_invoke("session");		
		}
	},
	redirect:function(url){ /*** 页面跳转 ***/
		$kmobile.kabalamobile_invoke("redirect",{url:url});		
	},
	newpage:function(url,title,showmore,param){/*** 打开一个覆盖的page页面 ***/
		$kmobile.kabalamobile_invoke("newpage",{url:url,title:title,showmore:showmore,param:JSON.stringify(param)});	
	},
	openfile:function(filepath,datahash,action){/*** 打开一个文件 action=share为分享，不填为打开 ***/
		$kmobilebridge.openfile(filepath,datahash,action);
	},	
	download:function(filepath,datahash){/*** 下载一个文件 ***/
		$kmobilebridge.downloadfile(JSON.stringify(filepath),datahash);
	},	
	startupload:function(dirpath){
		$kmobilebridge.startupload(dirpath);	 
	},
	notification:function(param){/*** msgtitle,msgtext,msgurl ***/
		$kmobilebridge.sendlocalservice("notification",JSON.stringify(param));
	},
	sharefilelink:function(filelink){/*** 分享链接 ***/
		$kmobile.kabalamobile_invoke("sharefilelink",{filelink:filelink});
	},
	sharetome:function(dirpath){
		$kmobile.kabalamobile_invoke("sharetome",{dirpath:dirpath});
	},
	transferfilelist:function(){
		$kmobile.kabalamobile_invoke("transferfilelist",null);
	},
	clearclientcache:function(){/*** 清理缓存 ***/
		$kmobilebridge.clearclientcache();
	}
}
module.exports=$kmobile